import { render, staticRenderFns } from "./MenuList.vue?vue&type=template&id=1da5c2e2&scoped=true"
import script from "./MenuList.vue?vue&type=script&lang=js"
export * from "./MenuList.vue?vue&type=script&lang=js"
import style0 from "./MenuList.vue?vue&type=style&index=0&id=1da5c2e2&prod&lang=less&scoped=true"
import style1 from "./MenuList.vue?vue&type=style&index=1&id=1da5c2e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da5c2e2",
  null
  
)

export default component.exports